<template>
  <b-collapse v-bind="$attrs" :class="{'side-menu' : !childMenu, 'child_menu': childMenu}"
              class="nav"
              tag="ul"
              :id="id"
              :value="value"
              @input="$emit('input', $event)"
              :accordion="accordion"
              :visible="!childMenu"

  >
    <slot></slot>
  </b-collapse>
</template>

<script>
export default {
  name: "SidebarMenu",
  props: {
    childMenu: Boolean,
    id: String,
    value: Boolean
  },
  computed: {
    accordion() {
      return this.childMenu ? 'childMenu' : null;
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>